import * as api from '../api';

let workoutCache = false;
const basePath20 = '/2.0/coach/calendar/workout';
export const getAll = async (page, pageSize) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;

    return await api.get(`/1.0/coach/workouts${queryString}`);
};

export const deleteSetExercise = async (workoutSetId, workoutSetExerciseId) =>
    // eslint-disable-next-line
    await api.del(`${basePath20}/workoutSetExercise/${workoutSetId}/${workoutSetExerciseId}`);

export const replaceWorkoutSetWithCombo = async (workoutSetId, comboId) =>
    // eslint-disable-next-line
    await api.post(`${basePath20}/workoutSet/replaceWorkoutSetWithCombo/${workoutSetId}/${comboId}`, null);

export const saveWorkout = async workout =>
    await api.put(`/3.0/coach/workout/${workout.workout_id}`, workout, null);

export const saveWorkoutAsTemplate20 = async (workoutId, workout = null) =>
    await api.post(
        `/2.0/coach/calendar/programWorkout/saveWorkoutAsTemplate/${workoutId}`,
        workout
    );

export const saveWorkoutSet = async theSet =>
    await api.post(`${basePath20}/workoutSet/save/${theSet.id}`, theSet);

export const saveWorkoutSetExercises = async workoutSetExercises =>
    await api.post(
        '/2.0/coach/calendar/saveWorkoutSetExercises',
        workoutSetExercises
    );

export const search = async q => await api.get(`/1.0/coach/workouts?q=${q}`);

export const setupWorkoutCache = () => {
    if (workoutCache === false) {
        workoutCache = search('');
    }
    return workoutCache;
};
